<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableBooleanColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableBooleanColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import PosRequest from './PosRequest';
import StoreUnlinkTerminalVue from './components/StoreUnlinkTerminal.vue';

export default {
  name: 'PosCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: PosRequest,
    editRoute: 'pos.edit',
    hideDelete: true,
    headers: [
      {
        text: 'ID',
        value: 'id',
      },
      {
        text: 'Troca habilitada',
        value: 'indHabilitaRemocaoTroca',
        component: DataTableBooleanColumnVue,
      },
      {
        text: 'Modelo',
        value: 'nomModeloTerminalPos',
      },
      {
        text: 'Número de série',
        value: 'numSerie',
      },
      {
        text: 'COD. Terminal SGV',
        value: 'codTerminalSgv',
      },
      {
        text: 'ID Chip',
        value: 'numIccidChip',
      },
      {
        text: 'Loja',
        value: 'loja.nomLoja',
      },
      {
        text: 'CNPJ Loja',
        value: 'loja.numCnpj',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Documento Cliente',
        value: 'loja.numDocumentoCliente',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Data de criação',
        value: 'createdDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Data de atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Vínculo',
        value: 'id',
        component: StoreUnlinkTerminalVue,
      },
    ],
  }),
};
</script>
